export const watcherCompensationFund = (watcher : any, 
    setModalContent : any, 
    setValue : any,
    setIsOpenModal : any,
    modalBlockDifferentCompensationFund :any
    ) => {
            if(watcher){
             if(watcher !== "99919031"){
                 setModalContent({   
                     title: modalBlockDifferentCompensationFund.title ? modalBlockDifferentCompensationFund.title : "",
                     image: modalBlockDifferentCompensationFund.icon ? modalBlockDifferentCompensationFund.icon : "",
                     description: modalBlockDifferentCompensationFund.description ? modalBlockDifferentCompensationFund.description : "",
                     textButton: modalBlockDifferentCompensationFund.primaryButton.title ? modalBlockDifferentCompensationFund.primaryButton.title : "",
                     url: modalBlockDifferentCompensationFund.primaryButton.url ? modalBlockDifferentCompensationFund.primaryButton.url : setIsOpenModal(false),
                     textButtonOpcional: modalBlockDifferentCompensationFund.secundaryButton.title ? modalBlockDifferentCompensationFund.secundaryButton.title : "",
                     urlOpcional: modalBlockDifferentCompensationFund.secundaryButton.url ? modalBlockDifferentCompensationFund.secundaryButton.url : "",
                     openSelf : true,
                });
                 setValue("compensationFund", "");
                 setIsOpenModal(true);
             }
            }
        
}
